import { render, staticRenderFns } from "./appointmentForm.vue?vue&type=template&id=c7864b06&scoped=true"
import script from "./appointmentForm.vue?vue&type=script&lang=js"
export * from "./appointmentForm.vue?vue&type=script&lang=js"
import style0 from "./appointmentForm.vue?vue&type=style&index=0&id=c7864b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7864b06",
  null
  
)

export default component.exports